<template>
  <div class="ranking-register" :class="{ 'in-teams': records === 2 }">
    <div v-show="records === 0 && dataList != null" class="rank">
      <!-- 战队排名 -->
      <template v-if="isInterdict">
        <Interdict></Interdict>
      </template>
      <template v-else>
        <div class="rank-left">
          <div class="notice" @click="handleClickshowRen"></div>
          <div class="rank-box">
            <div class="title-box">
              <div class="title">
                <div class="item title1">
                  <div class="bg"></div>
                  <div class="label-box">
                    <span class="label-shadow">排名</span>
                    <span class="label-text">排名</span>
                  </div>
                </div>
                <div class="item title2">
                  <div class="bg"></div>
                  <div class="label-box">
                    <span class="label-shadow">战队名称</span>
                    <span class="label-text">战队名称</span>
                  </div>
                </div>
                <div class="item title3">
                  <div class="bg"></div>
                  <div class="label-box">
                    <span class="label-shadow">人气值</span>
                    <span class="label-text">人气值</span>
                  </div>
                </div>
              </div>
            </div>

            <div class="list-box">
              <div class="list" v-if="dataList && dataList.clanRank">
                <div v-for="(item, index) in dataList.clanRank"
                  :class="{ 'list-item': true, selected: index === activeIndex }" :key="index"
                  @click="toggleActive(index)">
                  <div class="first">
                    <div class="label-box">
                      <span class="label-shadow">{{ index + 1 }}</span>
                      <span class="label-text">{{ index + 1 }}</span>
                    </div>
                  </div>
                  <div class="avatar" :style="{ 'background-image': `url(${item?.avatar})` }">
                  </div>
                  <div class="name">
                    {{ item?.name }}
                  </div>
                  <div class="hot">
                    {{ countShow(item?.popularity) }}
                  </div>
                  <ui-frame-bg class="rank-gift" colorType="blue" hook @click.native="goGift(item)">
                    <div class="label-box">
                      <span class="label-shadow">送礼</span>
                      <span class="label-text">送礼</span>
                    </div>
                  </ui-frame-bg>
                </div>
              </div>
            </div>

          </div>

        </div>

        <div class="rank-right">
          <!-- 前三名 -->
          <div class="user">
            <div class="user-item" v-for="(item, index) in fanListTop3" :key="index">
              <div class="user-info">
                <div class="user-img" :style="{
                  'background-image': `url(${item?.avatarUrl || defaultUrl
                    })`
                }">
                </div>
                <div class="info-box">
                  <div class="rank" :data-rank="`rank-${index + 1}`">
                    <div class="label-box">
                      <span class="label-shadow">NO.{{ index + 1 }}</span>
                      <span class="label-text">NO.{{ index + 1 }}</span>
                    </div>
                  </div>
                  <div class="user-name">
                    <div class="label-box">
                      <span class="label-shadow">{{ item?.nickName }}</span>
                      <span class="label-text">{{ item?.nickName }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="popularity" :data-rank="`rank-${index + 1}`">
                <i class="place"></i>
                <div class="label-box">
                  <span class="label-shadow">
                    {{ item?.popularity >= 10000 ? (item?.popularity / 10000).toFixed(2) + '万' : item?.popularity }}
                  </span>
                  <span class="label-text">
                    {{ item?.popularity >= 10000 ? (item?.popularity / 10000).toFixed(2) + '万' : item?.popularity }}
                  </span>
                </div>
              </div>
            </div>
          </div>


          <!-- 详情 -->
          <div class="fan-center">
            <div class="title-box">
              <div class="item title1">
                <div class="bg"></div>
                <div class="label-box">
                  <span class="label-shadow">排名</span>
                  <span class="label-text">排名</span>
                </div>
              </div>
              <div class="item title2">
                <div class="inner">
                  <div class="bg"></div>
                  <div class="label-box">
                    <span class="label-shadow">粉丝昵称</span>
                    <span class="label-text">粉丝昵称</span>
                  </div>
                </div>
              </div>
              <div class="item title3">
                <div class="bg"></div>
                <div class="label-box">
                  <span class="label-shadow">贡献值</span>
                  <span class="label-text">贡献值</span>
                </div>
              </div>
            </div>
            <div class="fan-box">
              <div class="fan-center-warp" v-if="filteredList && filteredList.length > 0">
                <div class="list-items" v-for="(item, index) in filteredList" :key="index">
                  <div class="first">
                    <div class="label-box">
                      <span class="label-shadow">{{ index + 4 }}</span>
                      <span class="label-text">{{ index + 4 }}</span>
                    </div>
                  </div>
                  <div class="nanu">
                    <div class="avatar" :style="{ 'background-image': `url(${item?.avatarUrl || defaultUrl})` }"></div>
                    <div class="name">
                      {{ item.nickName || '-' }}
                    </div>
                  </div>

                  <div class="hot">
                    {{ countShow(item?.popularity) }}
                  </div>
                </div>
                <div class="placeholder"></div>
              </div>
            </div>
          </div>
          <userTeamRankings :userInfo="dataList.personalGifts" :useImgUrl="useImgUrl" />
        </div>
      </template>
    </div>
    <!-- 个人排名 -->

    <div v-show="records === 1" class="personal">
      <template v-if="isInterdict">
        <Interdict></Interdict>
      </template>
      <template v-else>
        <personalRanking :personaList="personaList" :countShow="countShow" />
      </template>
    </div>

    <div v-show="records === 2" class="teamscontainer">
      <Team />
    </div>
    <!-- <GivePresent ref="present"></GivePresent> -->
  </div>
</template>




<script>
import * as api from '@/service/index'
import { mapState, mapMutations, mapActions } from 'vuex'
import userTeamRankings from '@/views/ranking/userTeamRankings'
// import GivePresent from '@/views/live/givePresent.vue'
import Team from '@/views/teams'
import Interdict from '@/components/interdict'
import personalRanking from '@/views/ranking/personal-ranking.vue'
import UiFrameBg from '@/components/ui-frame-bg.vue'

export default {
  components: {
    userTeamRankings,
    Team,
    // GivePresent,
    Interdict,
    personalRanking,
    UiFrameBg
  },
  inject: ['getTeamRankingsList', 'handleCkickshowRenqi'],

  data() {
    return {
      defaultUrl: 'https://website.xdcdn.net/form/match/avatar2024/Portrait1.png',
      avatarsUrl: [
        'https://website.xdcdn.net/poster/355916/sausage-match/ATRywtJ8.png',
        'https://website.xdcdn.net/poster/355916/sausage-match/ATRywIIo.png',
        'https://website.xdcdn.net/poster/355916/sausage-match/ATRywXck.png'
      ],
      avatarImgUrl: [
        "https://website.xdcdn.net/poster/58881/2024_EventsCentre/EIJ6tFW3.png",
        "https://website.xdcdn.net/poster/58881/2024_EventsCentre/EIJ6t4EG.png",
        "https://website.xdcdn.net/poster/58881/2024_EventsCentre/EIJ6tUvw.png"
      ],
      isSelected: false,
      // activeIndex: -1
      useImgUrl: ''
    }
  },
  props: {
    dataList: Object,
    records: Number,
    personaList: Object,
    activeIndex: Number,
    userInfo: Object,

    whip: {
      type: [String, Number],
      default: ''
    },
    bastard: {
      type: [String, Number],
      default: ''
    }
  },
  created() {
    if (!this.token) return;
    this.fetchGetGiftList({ token: this.token, force: true })
    this.getPathUrlImg()
  },
  mounted() {
    // console.log('mounted',)
  },
  computed: {
    ...mapState(['amount', 'token', 'isInterdict']),
    //
    //  筛选掉排名前三的数据
    fanListTop3() {
      return this.dataList.personal?.filter((item, index) => index <= 2)
    },
    filteredList() {
      return this.dataList.personal?.filter((item, index) => index > 2)
    },

  },
  methods: {
    ...mapMutations(['SHOW_POPUP']),
    ...mapActions(['reqUserInfo']),
    toggleActive(index) {
      // console.log(index)
      if (this.activeIndex === index) {
        return
      }
      this.getTeamRankingsList(index)
    },
    getPathUrlImg() {
      const storedAvatar = localStorage.getItem('DCavatar')
      const storedTaptapAvatar = localStorage.getItem('DCtaptapavatar')
      if (storedTaptapAvatar) {
        this.useImgUrl = storedTaptapAvatar
      } else if (storedAvatar) {
        this.useImgUrl = `https://website.xdcdn.net/form/match/avatar2024/${storedAvatar}.png`
      } else {
        // 个人头像兜底
        this.useImgUrl = this.defaultUrl
      }
    },
    handleClickshowRen() {
      this.handleCkickshowRenqi()
    },
    async goGift(item) {
      if (!this.token) return;
      let data = {
        token: this.token,
        force: false
      }
      try {
        this.SHOW_POPUP({
          id: 'present',
          params: {
            team: '',
            presentList: ''
          }
        })
        this.reqUserInfo(true)
        const res = await this.fetchGetGiftList(data)
        if (res.length) {
          // this.$refs.present.openPresent(item, res)
          this.SHOW_POPUP({
            id: 'present',
            params: {
              team: item,
              presentList: res
            }
          })
        }
      } catch (err) {
        console.log(err)
      }

    },
    async fetchGetGiftList(data) {
      try {
        const req = await api.reqGiftList(data)
        if (req.status === 200) {
          return req.data
        }
      } catch (err) {
        console.log(err)
      }
    },
    countShow(hot) {
      if (hot) {
        if (hot < 10000) {
          return hot
        } else if (10000 <= hot && hot < 99999999) {
          return (((hot / 10000) * 100) / 100).toFixed(2) + '万'
        } else {
          return 9999 + '万+'
        }
      } else {
        return 0
      }
    },
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/ranking/rank';
.ranking-register {
  box-sizing: border-box;
  position: relative;
  height: 100%;
  overflow-y: hidden;
  display: flex;
  @include paddingSet($paddingTop: 24px, $paddingRight: 15px, $paddingBottom: 20px, $paddingLeft: 15px);

  .personal {
    width: 100%;
    height: 100%;
    display: flex;
  }
  .teamscontainer{
    width: 100%;
    height: 100%;
    overflow: hidden;
  }

  &.in-teams {
    @include paddingSet($paddingTop: 27px, $paddingRight: 20px, $paddingBottom: 0px, $paddingLeft: 20px);
  }
}
</style>
